import React from 'react';

const TrashIcon = ({ width = 24, height = 24, color = 'currentColor' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-trash"
        >
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6l-1.5 14H6.5L5 6"></path>
            <line x1="9" y1="6" x2="9" y2="19"></line>
            <line x1="15" y1="6" x2="15" y2="19"></line>
            <path d="M10 3h4a2 2 0 0 1 2 2v1H8V5a2 2 0 0 1 2-2z"></path>
        </svg>
    );
};

export default TrashIcon;
